import { isFunction } from "lodash-es";

interface HotJarIdentifyOptions {
  userId?: number;
  profileId?: number;
}

export const hotjarIdentify = (options?: HotJarIdentifyOptions) => {
  const user_id = options?.userId ?? null;
  const profile_id = options?.profileId ?? null;

  if (window.hj && isFunction(window.hj)) {
    window.hj("identify", user_id, {
      user_id,
      profile_id,
    });
  }
};
